






































































































import { Vue, Component } from 'vue-property-decorator'
import { Validations } from 'vuelidate-property-decorators'
import { required, minLength, email, helpers, requiredIf } from 'vuelidate/lib/validators'
import { Validation } from 'vuelidate'

@Component({})
export default class RegisterForm extends Vue {
    @Validations()
    validations = {
      formFields: {
        business_name: { required },
        business_address: { required },
        rc_number: {
          required: requiredIf(() => this.state.businessHasCAC)
        },
        phone: { required, minLength: minLength(11) },
        email: { required, email }
      }
    }

    public formFields: any = {
      business_name: '',
      rc_number: '',
      business_address: '',
      contact_person: '',
      phone: '',
      email: ''
    }

    public state = {
      submitted: false,
      loading: false,
      businessHasCAC: false,
      formAlert: {
        type: '',
        message: ''
      }
    }

    public isBusinessNameRegistered (e: any) {
      this.state.businessHasCAC = e.target.value === 'YES'
    }

    public submitForm (e: any) {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.state.submitted = true
      fetch('https://apiv2.cleanagent.ng/api/v2/partners/register?api_access_token=9MC9s-lobNm-F9xCTXA-3R6C-8ifzswERTu', {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'User-Agent': 'Clean-Agent-Web',
          'Accept-Language': 'en-US',
          'Accept-Charset': 'ISO-8859-1,utf-8',
          'Origin': 'https://cleanagent.ng'
          // 'Origin': 'https://netlify.com'
        }),
        body: JSON.stringify(this.formFields)
        // body: this.formFields
      }) // Call the fetch function passing the url of the API as a parameter
        .then((res: any) => {
          this.state.submitted = false
          // Your code for handling the data you get from the API
          this.$v.$reset()
          Object.assign(this.state.formAlert, { type: 'success',
            message: ' Your application to be Cleanagent Service Partner  is a successfully submitted. \n' +
              'We will contact you shortly to complete your on-boarding process.\n' +
              '\n' + '<br />' +
              'Feel free to reach out to us via email support@cleanagent.ng or call +2349060009767  if your have further questions.  Thank you.' })
          for (let key in this.formFields) {
            if (this.formFields.hasOwnProperty(key)) {
              this.formFields[key] = ''
            }
          }
          setTimeout(() => {
            Object.assign(this.state.formAlert, { type: '', message: '' })
          }, 5000)
        })
        .catch((err : any) => {
          this.state.submitted = false
          console.error(err)
          Object.assign(this.state.formAlert, { type: 'error', message: 'Something went wrong!' })
          setTimeout(() => {
            Object.assign(this.state.formAlert, { type: '', message: '' })
          }, 5000)
          // This is where you run code if the server returns any errors
        })
    }
}
